import { Navigate, Outlet, useParams, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/UseAuth';
import Spinner from '../layout/Spinner';

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();
  // --- INICIO DE LA MODIFICACIÓN 1 ---
  const { lang } = useParams();
  const location = useLocation(); // Hook para obtener la ubicación actual
  // --- FIN DE LA MODIFICACIÓN 1 ---

  if (isLoading) {
    return <Spinner fullScreen={true} />;
  }

  // --- INICIO DE LA MODIFICACIÓN 2 ---
  // Si el usuario está autenticado, muestra el contenido.
  // Si no, lo redirige al login, pero ahora...
  // 1. Usa el prefijo de idioma correcto.
  // 2. Guarda en el 'state' la página que el usuario intentaba visitar.
  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate
      to={`/${lang || 'es'}/login`}
      state={{ from: location }} // <-- ¡Mejora clave!
      replace
    />
  );
  // --- FIN DE LA MODIFICACIÓN 2 ---
};

export default ProtectedRoute;
